import { BreadcrumbBlock } from '@/payload-types';

import { CMSLink } from '@/components/Link';
import { Fragment } from 'react';
import { cn } from '@/utilities/cn';

interface IBreadcrumb {
  links: BreadcrumbBlock;
  classNameList?: string;
}

const Breadcrumb = (props: IBreadcrumb) => {
  const { links, classNameList = '' } = props;

  return (
    <div className="bg-background-light">
      <nav className="container">
        <ul className={cn(
          'flex items-center py-4 overflow-x-auto',
          classNameList
        )}>
          {links?.breadcrumb?.map((item, index) => (
            <li key={index}>
              {(links?.breadcrumb?.length || 0) - 1 !== index ? (
                <Fragment>
                  <CMSLink
                    {...item?.link}
                    className='text-sm leading-5 text-neutral-500 hover:text-neutral-1000 transition-all duration-150 delay-100 font-medium whitespace-nowrap'
                  />
                  <span className="px-2 text-neutral-500">/</span>
                </Fragment>
              ) : (
                <p className='text-neutral-1000 font-semibold cursor-auto text-sm leading-5 whitespace-nowrap'>
                  {item?.link?.label}
                </p>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Breadcrumb;
